export const APPLICATION_ROUTES = {
  BASE_URL: 'simpayx',
  RESTAURANT: 'restaurant',
  PICKUP: 'pickup',
  SITE_URL: 'https://dinein.simpexo.com/',
  CHECKOUT: 'checkout',
  LOGISTIC: 'logistic',
  // ORDER_STATUS: "order-status",
  // PAYMENT: "payment",
  RESERVATION: 'reservation',
  // RESERVATION_REVIEW: "review",
  // RESERVATION_COMPLETED: "complete",
  // RESERVATION_CONFIRMATION: "confirm",
  VOUCHER: 'voucher',
  // FEEDBACK: "feedback",
  // ORDER_TYPE: "order-type",
  // OFFLINE_PAYMENT: "offline-payment",
  // LANDING: "landing",
};
